import Vue from 'vue'
import App from './App.vue'
import router from './router'

import SwfPlayer from '@/components/SwfPlayer';
import LightboxLink from '@/components/LightboxLink';
import Lightbox from '@/components/Lightbox';
import ImageLoader from '@/components/ImageLoader';
import Head from '@/components/Head';
import VueAnalytics from 'vue-analytics'
import detect from 'detect-browser';
import MobileDetect from 'mobile-detect';
import Youtube from '@/components/YoutubePlayer';

Vue.component('swf-player', SwfPlayer);
Vue.component('light-box', Lightbox);
Vue.component('light-box-link', LightboxLink);
Vue.component('swf-player', SwfPlayer);
Vue.component('img2', ImageLoader);
Vue.component('hh', Head);
Vue.component('youtube', Youtube);


const md = new MobileDetect(window.navigator.userAgent);

Vue.config.productionTip = false;

Vue.prototype.$bus = new Vue();
Vue.prototype.$isIE = detect.detect().name == 'ie';
Vue.prototype.$isSafari = detect.detect().name == 'safari';
Vue.prototype.$imageCount = 0;
Vue.prototype.$isMobile = md.mobile() != null;



Vue.use(VueAnalytics, {
    id: 'UA-7021654-1',
    router
});


new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
